/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import EntityTags from './EntityTags';
import { Wrapper, Title, Entities, Edit } from './styled';
import { openModal } from 'store/modals/actions';
import { MODAL_TAGS_IN_AGENTS } from 'store/modals/modals';
import { get } from 'lodash';
import { setTagsAgent } from 'store/Agents/actions';
import { selectAssetsTags, selectServicesTags, SelectShowCloudAgents, selectTriggerAgent, selectVulnsTags } from 'store/Agents/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const TagsSection = ({ toolId, isExpanded, disabled }) => {
  const dispatch = useDispatch();
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));
  const selectedAgent = useSelector(selectTriggerAgent);
  const vulnTag = useSelector(selectVulnsTags);
  const serviceTag = useSelector(selectServicesTags);
  const hostTag = useSelector(selectAssetsTags);
  const isCloudAgent = useSelector(SelectShowCloudAgents);
  const executors = get(selectedAgent, 'executors', []);
  const executor = executors.find((executor) => executor.id === toolId);
  const data = isCloudAgent ? selectedAgent : executor;
  const assetsTagsAdded = get(data, 'parameters_data.host_tag', []);
  const vulnsTagsAdded = get(data, 'parameters_data.vuln_tag', []);
  const servicesTagsAdded = get(data, 'parameters_data.service_tag', []);
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'agents.triggerAgent.tags.title' });

  useEffect(() => {
    (!isCloudAgent && isExpanded) && dispatch(setTagsAgent({ vuln_tag: vulnTag, service_tag: serviceTag, host_tag: hostTag }));
  }, [vulnTag, serviceTag, hostTag]);

  useEffect(() => {
    (!isCloudAgent && isExpanded) && dispatch(setTagsAgent({ vuln_tag: vulnsTagsAdded, service_tag: servicesTagsAdded, host_tag: assetsTagsAdded }));
  }, [isExpanded]);

  if (!hasTagsFeature) return null;

  return (
    <Wrapper>
      <Title children={ title } />
      <Entities>
        <EntityTags entity="assets" values={ hostTag } />
        <EntityTags entity="vulnerabilities" values={ vulnTag } />
        <EntityTags entity="services" values={ serviceTag } />
      </Entities>
      <Edit id="open-modal-tags-in-agents" onClick={ () => dispatch(openModal(MODAL_TAGS_IN_AGENTS)) } disabled={ disabled }>Edit</Edit>
    </Wrapper>
  );
};

export default TagsSection;
